module.exports = __webpack_public_path__ + "static/media/video-camera.f0d972fb.png";